export default __webpack_public_path__ + "static/media/card-proxxima.7936e9ba.png";